import { Injectable, NgZone } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { AppEnvConfig } from '../../../app.env.config';
import { UserSettings } from '../../../shared/models/User';
import { UserService } from '../../user/user.service';

@Injectable()
export class AuthenticationGuard {
  constructor(
    private router: Router,
    private userService: UserService,
    private translation: TranslateService,
    private loadEnv: AppEnvConfig, private zone: NgZone
  ) {
  }

  canLoad(route: Route): boolean {
    if (this.userService.userInfo) {
      return true;
    } else {
      const url = `/${route.path}`;
      this.router.navigate(['/login'], { queryParams: { returnUrl: url } });
    }
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const user: UserSettings = this.userService.getCurrentSettings();
    if (user && user.Permissions) {
      // console.log('route guard passed succesfully for ' + state.url);
      const userCulture = user.Culture.match(/en|es|pt|zh|de|nl|fr|ru|it|ko|ja/);
      const userLanguage = userCulture != null ? userCulture[0] : 'en';
      this.translation.use(userLanguage);
      return of(true);
    } else {
      this.zone.run(() => {
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      });
      return of(false);
    }
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.canActivate(childRoute, state);
  }
}
